import React from 'react';
import { SpinnerIconWrapper } from './styled';
import SpinnerIcon from 'assets/svg/spinner.svg';

const Spinner: React.FC<{ size?: number }> = ({ size = 24 }) => {
  return <SpinnerIconWrapper><SpinnerIcon width={size} height={size} /></SpinnerIconWrapper>;
};

export default Spinner;
